import { ProjectStateProject } from 'src/services/project/redux';

export const contentComparer = (project: Pick<ProjectStateProject, 'defaultLanguageId'>) => (c1: any, c2: any) => {
  if (c1.languageId === project.defaultLanguageId) return -1;
  if (c2.languageId === project.defaultLanguageId) return 1;

  return c1.languageId < c2.languageId ? -1 : 1;
};
